import { render, staticRenderFns } from "./UserGrantData.vue?vue&type=template&id=3f820acf&scoped=true&"
import script from "./UserGrantData.vue?vue&type=script&lang=js&"
export * from "./UserGrantData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f820acf",
  null
  
)

export default component.exports